import React from "react";
import moment from "moment";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import { formatearFecha } from "../../../../helpers/formatearFecha";

// Dato de solo lectura que explica de dónde sale la fecha de corte mínima
const CampoInformativo = ({ etiqueta, fecha, vacio }) => (
    <div className="formulario-field">
        <label className="m-0 text-nowrap">{etiqueta}</label>
        <input
            type="text"
            className="form-control"
            value={formatearFecha(fecha)}
            placeholder={vacio}
            disabled
        />
    </div>
);

// Los filtros van en orden porque cada uno depende del anterior. Del producto
// padre depende el resto: en su primer cierre se elige el periodo inicial y se
// muestra desde cuándo tiene producción; en los siguientes se muestra la
// reanudación si la producción se detuvo, o si no el último corte. La fecha de
// corte va al final, aparece cuando ya se conoce su mínimo y se limpia al
// cambiar el producto padre o el periodo inicial
export const FiltrosCierreProduccion = ({ hook }) => {
    const {
        formControl,
        formErrors,
        formSetValue,
        loadPadresProductoTerminado,
        siguienteCierre,
        fechaCorteMinima,
        consultarReporte,
        limpiarConsulta,
        cargando,
    } = hook;

    // la consulta en pantalla deja de corresponder en cuanto cambia un filtro
    const cambiarFiltro = (field, valor) => {
        limpiarConsulta();
        field.onChange(valor);
    };

    const esPrimerCierre =
        Boolean(siguienteCierre) && siguienteCierre.es_primer_cierre;

    return (
        <div className="formulario-fields-row my-0">
            <div className="formulario-field" style={{ minWidth: "220px" }}>
                <label
                    htmlFor="padre_producto_terminado"
                    className="m-0 text-nowrap"
                >
                    Producto padre
                </label>
                <Controller
                    name="padre_producto_terminado"
                    control={formControl}
                    rules={{ required: "Seleccione el producto padre" }}
                    render={({ field }) => (
                        <AsyncSelect
                            {...field}
                            className="react-select-container"
                            isSearchable
                            isClearable
                            cacheOptions
                            defaultOptions
                            loadOptions={loadPadresProductoTerminado}
                            getOptionValue={(option) => option.id}
                            getOptionLabel={(option) => option.nombre}
                            placeholder="Seleccionar"
                            onChange={(selected) => {
                                cambiarFiltro(field, selected);
                                // el periodo inicial y la fecha de corte
                                // dependen del producto padre
                                formSetValue("periodo_inicial", null);
                                formSetValue("fecha_corte", null);
                            }}
                        />
                    )}
                />
                {formErrors.padre_producto_terminado && (
                    <small className="text-danger">
                        {formErrors.padre_producto_terminado.message}
                    </small>
                )}
            </div>

            {esPrimerCierre && (
                <div className="formulario-field" style={{ minWidth: "220px" }}>
                    <label
                        htmlFor="periodo_inicial"
                        className="m-0 text-nowrap"
                    >
                        Periodo inicial
                    </label>
                    <Controller
                        name="periodo_inicial"
                        control={formControl}
                        rules={{ required: "Seleccione el periodo inicial" }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="react-select-container"
                                // isSearchable={false}
                                options={siguienteCierre.periodos_iniciales}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.periodo}
                                placeholder="Seleccionar"
                                noOptionsMessage={() =>
                                    "No hay periodos con envíos a producción de este producto padre"
                                }
                                onChange={(selected) => {
                                    cambiarFiltro(field, selected);
                                    // la fecha de corte mínima depende del
                                    // periodo inicial
                                    formSetValue("fecha_corte", null);
                                }}
                            />
                        )}
                    />
                    {formErrors.periodo_inicial && (
                        <small className="text-danger">
                            {formErrors.periodo_inicial.message}
                        </small>
                    )}
                </div>
            )}

            {esPrimerCierre && (
                <CampoInformativo
                    etiqueta="Inicio de producción"
                    fecha={siguienteCierre.inicio_de_produccion}
                    vacio="Sin producción"
                />
            )}

            {siguienteCierre &&
                !esPrimerCierre &&
                (siguienteCierre.produccion_reanudada ? (
                    <CampoInformativo
                        etiqueta="Producción reanudada"
                        fecha={siguienteCierre.produccion_reanudada}
                    />
                ) : (
                    <CampoInformativo
                        etiqueta="Fecha del último corte"
                        fecha={siguienteCierre.fecha_ultimo_corte}
                    />
                ))}

            {fechaCorteMinima && (
                <div className="formulario-field">
                    <label htmlFor="fecha_corte" className="m-0 text-nowrap">
                        Fecha de corte
                    </label>
                    <Controller
                        name="fecha_corte"
                        control={formControl}
                        rules={{ required: "Seleccione la fecha de corte" }}
                        render={({ field }) => (
                            <DatePicker
                                selected={field.value}
                                onChange={(date) => cambiarFiltro(field, date)}
                                showPopperArrow={false}
                                dateFormat="DD/MM/YYYY"
                                placeholderText="Fecha de corte"
                                minDate={fechaCorteMinima}
                                // maxDate={moment()}
                            />
                        )}
                    />
                    {formErrors.fecha_corte && (
                        <small className="text-danger">
                            {formErrors.fecha_corte.message}
                        </small>
                    )}
                </div>
            )}
            <div
                className="formulario-field mb-0 no-flex"
                style={{ maxHeight: "51px" }}
            >
                <button
                    className="btn btn-primary mt-auto"
                    onClick={consultarReporte}
                    disabled={cargando}
                >
                    Consultar
                </button>
            </div>
        </div>
    );
};
